import { lazy } from 'react'
import { MappedSportWithNationality } from '../types'
import type { MappedSportWithFlagsProps } from './types'

export const mappedSportsWithNationalFlags: Record<
  MappedSportWithNationality,
  React.LazyExoticComponent<React.FC<MappedSportWithFlagsProps>>
> = {
  F1: lazy(() => import('./Individuals/F1')),
  UFC: lazy(() => import('./Individuals/UFC')),
  Basketball: lazy(() => import('./Teams/BasketballNational')),
  Cricket: lazy(() => import('./Teams/CricketNational')),
  Football: lazy(() => import('./Teams/FootballNational')),
  RugbyLeague: lazy(() => import('./Teams/RugbyLeagueNational')),
  RugbyUnion: lazy(() => import('./Teams/RugbyUnionNational')),
}
